import React, { useEffect, useState, useRef} from 'react'
import AppLayout from '../../../../../layout/components/AppLayout'
import { useParams } from 'react-router-dom'
import invoiceServices from '../invoiceServices';
import { useAppData } from '../../../../../context/AppDataContext';
import InvoiceHeader from '../components/InvoiceHeader';
import InvoiceItemList from '../components/InvoiceItemList';
import InvoiceFooter from '../components/InvoiceFooter';
import { useReactToPrint } from 'react-to-print';
import { Print } from '@mui/icons-material';
import InvoiceForm from '../components/InvoiceForm';


function InvoiceDetailsPage() {
  const {id} = useParams();

  const printComponentRef = useRef();

  const [companyDetails,setCompanyDetails] = useState(null);
  const [customerDetails,setCustomerDetails] = useState(null);

  const [invoiceDetails,setInvoiceDetails] = useState(null);
  
  const {productList,getProductList} = useAppData();

  const getInvoiceDetails = () =>{
    invoiceServices.getById(id).then(res=>{
      setInvoiceDetails(res.data);
    }).catch(error=>{
      console.log(error);
    })
  }

  useEffect(()=>{
    getInvoiceDetails();
    getProductList();
  },[id])

  const [isPrinting,setIsPrinting] = useState(false);

  const printInvoice = () =>{
    setIsPrinting(true);
    setTimeout(handlePrint,100)
  }

  const handlePrint = useReactToPrint({
    onBeforePrint :() =>{
      setIsPrinting(true);
    },
    onAfterPrint : ()=>{
      setIsPrinting(false);
    },
    content: () => printComponentRef.current,
    // Standard A4 or Letter size logic
    pageStyle: `
        @page { 
            size: auto; 
            margin: 10mm; 
        }
        @media print {
            body { -webkit-print-color-adjust: exact; }
        }
    `
  });

  return (
    <AppLayout>
        <style>
          {
            `
            table {page-break-after:unset}
            `
          }
        </style>
        {invoiceDetails && 
          <div className='container'>

            <div className='row'>
              <div className='col-md-12'>
              </div>
              <div className='col-md-12'>
                <div className='row mb-2'>
                  <div className='col-md-12'>
                    <InvoiceForm data={invoiceDetails} callBack={getInvoiceDetails} />
                    <button className='btn btn-outline-primary float-end' onClick={printInvoice} ><Print/> Print</button>
                    
                  </div>
                </div>
                <div ref={printComponentRef} >
                  <div className='row'>
                    <div className='col-md-12'>
                      <InvoiceHeader 
                        invoiceDetails={invoiceDetails}
                        companyDetails={companyDetails}
                        setCompanyDetails={setCompanyDetails}
                        customerDetails={customerDetails}
                        setCustomerDetails={setCustomerDetails}
                        callBack={getInvoiceDetails}
                      />
                    </div>

                    <div className='col-md-12 mt-2'>
                      <InvoiceItemList 
                        invoiceDetails={invoiceDetails} productList={productList} isPrinting={isPrinting}
                      />
                    </div>

                    <div className='col-md-12 mt-2'>
                      <InvoiceFooter
                        invoiceDetails={invoiceDetails}
                        companyDetails={companyDetails}
                        customerDetails={customerDetails}
                      />
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        }
    </AppLayout>
  )
}

export default InvoiceDetailsPage